import React, { Component, Fragment } from 'react'
import { RadioGroup, FormControlLabel } from "@material-ui/core";
import { MuiDateRange } from '../../../ui/MaterialUIComponents'
import { MuiGrid, MuiTypography, MuiEdit, MuiPaper } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import { WeeklyAvailabilityScheduleComponent } from '../../weeklyAvailability';
import { Radio } from '../../../ui/customUIComponents'
export class RadioButtonComponent extends Component {
  render() {
    const { i18n } = this.props
    return (<Fragment>

      <MuiGrid container xs={12}>
        <MuiGrid item xs={3} direction="column">
          <RadioGroup
            id='availability'
            aria-label="position"
            name="position"
            spacing={16}
            onChange={event => this.props.handleChangeOfRadioButton(event)}
            value={
              this.props.weeklyAvailability.availableForAllHours
            }
          >
            <FormControlLabel
              value="true"
              control={<Radio size="small" />}
              label={<MuiTypography style={theme.typography.body2}>{i18n.teachers.availableHours}</MuiTypography>}
              labelPlacement="end"
            />
            <FormControlLabel
              value="false"
              control={<Radio size="small" />}
              label={<MuiGrid container direction="row" alignItems="center">
                <MuiGrid item>
                  <MuiTypography style={theme.typography.body2}>{i18n.teachers.notAvailableHours}</MuiTypography>
                </MuiGrid>
                <MuiGrid item>
                  <MuiDateRange style={{ color: theme.palette.grey.light }} />
                </MuiGrid>
              </MuiGrid>}
              labelPlacement="end"
              onClick={event => this.props.onClickOfRadioButton(event)}
            />
          </RadioGroup>
          <MuiGrid container xs={12} alignContent="left">
            {this.props.isScheduleOpen === true && (
              <MuiPaper variant="outlined" style={{ position: "absolute", zIndex: 1, width: 1000, padding: 16, boxSizing: 'border-box' }}>
                <WeeklyAvailabilityScheduleComponent
                  {...this.props}
                  {...this.state} />
              </MuiPaper>
            )}
          </MuiGrid>
        </MuiGrid>
        <MuiGrid item container xs>
          <MuiGrid container direction="row" justify="flex-start"  >
            {this.props.weeklyAvailabilityDisplayList != undefined && this.props.weeklyAvailabilityDisplayList.length > 0
              && this.props.weeklyAvailabilityDisplayList.map(weeklyAvailability => (
                <MuiGrid item container xs={7} justify="flex-start" >
                  <a href="#"><MuiTypography onClick={event => this.props.onClickOfRadioButton(event)} variant="body2" gutterBottom style={theme.gridHeaderTextStyle} align="left" >{weeklyAvailability}</MuiTypography></a>
                </MuiGrid>
              ))}
          </MuiGrid>
        </MuiGrid>
      </MuiGrid>

    </Fragment>

    )
  }
}

export default RadioButtonComponent
